import * as React from 'react';
import moment from 'moment';
import { IoChevronBack, IoChevronForward, IoCheckmarkCircle, IoClose } from "react-icons/io5";
import { FaClipboardUser } from "react-icons/fa6";
import { HiUserGroup } from "react-icons/hi2";
import { RiLockPasswordFill } from "react-icons/ri";
import { toast } from 'react-toastify';
import { addNewMember } from '../../service/service-call';

const inputClass =
  "w-full rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800 outline-none transition-colors focus:border-[#262673] focus:ring-2 focus:ring-[#262673]/10";
const labelClass = "mb-1.5 block text-xs font-semibold text-gray-500";

function Field({ label, required, hint, children }) {
  return (
    <div className="mb-4">
      <label className={labelClass}>
        {label} {required && <span className="text-red-400">*</span>}
      </label>
      {children}
      {hint && <p className="mt-1 text-right text-[10px] text-gray-300">{hint}</p>}
    </div>
  );
}

export default function AddMembers({ addMemberModal }) {
  let roleObj = [
    { label: "Super Admin", value: "ROLE_SUPER_ADMIN" },
    { label: "Admin", value: "ROLE_ADMIN" },
    { label: "User", value: "ROLE_USER" },
  ];

  if (localStorage.getItem("role") === "ROLE_ADMIN") {
    roleObj = [{ label: "User", value: "ROLE_USER" }];
  }

  const [overallExperience, setOverallExperience] = React.useState("0 years, 0 months");
  const [year, setYears] = React.useState(0);
  const [month, setMonths] = React.useState(0);
  const [fname, setFName] = React.useState('');
  const [lname, setLName] = React.useState('');
  const [mobile, setMobile] = React.useState('');
  const [email, setEmail] = React.useState('');
  const [role, setRole] = React.useState('');
  const [memberId, setMemberId] = React.useState('');
  const [password, setPassword] = React.useState('Waves@123');
  const [designation, setDesignation] = React.useState('');
  const [dob, setDob] = React.useState(null);
  const [doj, setDoj] = React.useState(new Date());
  const [gender, setGender] = React.useState('female');
  const [experience, setExperience] = React.useState(0);
  const [address, setAddress] = React.useState("");
  const [submitting, setSubmitting] = React.useState(false);

  const handleDesignationChange = (e) => setDesignation(e.target.value);
  const handleRoleChange = (e) => setRole(e.target.value);

  function ValidateEmail(mail) {
    return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail);
  }

  function phonenumber(mobile) {
    var phoneno = /^\d{10}$/;
    return !!mobile.match(phoneno);
  }

  const getOverallExperience = (dateString, oldExperienceYears, oldExperienceMonths) => {
    var joinDate = moment(dateString);
    if (!oldExperienceYears) oldExperienceYears = Number(0);
    if (!oldExperienceMonths) oldExperienceMonths = Number(0);

    var currentDate = moment();
    var newExperience = moment.duration(currentDate.diff(joinDate));

    var yearsExperience = Number(newExperience.years()) + Number(oldExperienceYears);
    var monthsExperience = Number(newExperience.months()) + Number(oldExperienceMonths);

    if (monthsExperience >= 12) {
      yearsExperience += Math.floor(monthsExperience / 12);
      monthsExperience = monthsExperience % 12;
    }

    setOverallExperience(Number(yearsExperience) + " years, " + monthsExperience + " months");
  };

  const handleGenderChange = (event) => setGender(event.target.value);
  const handleFirstNameChange = (e) => setFName(e.target.value);

  const handleMonthChange = (e) => {
    const val = Number(e.target.value);
    setMonths(val);
    setExperience(year + "." + val);
    getOverallExperience(doj, year, val);
  };

  const handleYearChange = (e) => {
    const val = e.target.value;
    setYears(val);
    setExperience(val + "." + month);
    getOverallExperience(doj, val, month);
  };

  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleLastNameChange = (e) => setLName(e.target.value);
  const handleIdChange = (e) => setMemberId(e.target.value);
  const handleMobileChange = (e) => setMobile(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);

  const handleDobChange = (e) => setDob(e.target.value);
  const handleDojChange = (e) => {
    setDoj(e.target.value);
    getOverallExperience(e.target.value, year, month);
  };

  function validateBasic() {
    if (fname === "" || fname === undefined || lname === "" || lname === undefined ||
      mobile === "" || mobile === undefined || email === "" || email === undefined ||
      !doj || !dob || doj === null || doj === "" || doj === undefined || dob === null || dob === "" || dob === undefined) {
      toast.error('Fields cannot be blank');
      return false;
    } else if (!ValidateEmail(email)) {
      toast.error('Email is not valid');
      return false;
    } else if (!phonenumber(mobile)) {
      toast.error('Mobile number is not valid');
      return false;
    } else {
      return true;
    }
  }

  function validateCredential() {
    if (memberId === "" || memberId === undefined || password === "" || password === undefined) {
      toast.error('Member credentials cannot be blank');
      return false;
    } else {
      return true;
    }
  }

  function addNewMembers() {
    if (fname === "" || fname === undefined || lname === "" || lname === undefined ||
      designation === "" || designation === undefined || role === "" || role === undefined ||
      mobile === "" || mobile === undefined || email === "" || email === undefined ||
      address === "" || address === undefined || gender === "" || gender === undefined) {
      toast.error('Fields cannot be blank');
    } else {
      setSubmitting(true);
      addNewMember(memberId, password, fname, lname, mobile, email, designation, role, address, experience, moment(doj).format("YYYY-MM-DD"), moment(dob).format("YYYY-MM-DD"), gender).then(resp => {
        setSubmitting(false);
        toast.success('Member added successfully');
        addMemberModal();
      }).catch(error => {
        setSubmitting(false);
        if (error && error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
        } else if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
          toast.error(error.response.data.errors[0]);
        } else {
          toast.error("Internal server error, contact support team");
        }
      });
    }
  }

  const steps = [
    {
      label: 'Employee Details',
      icon: <FaClipboardUser size={22} className="text-[#0B6BCB]" />,
      validate: validateBasic,
      description: (
        <>
          <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
            <Field label="First Name" required hint={`${fname.length}/15`}>
              <input className={inputClass} type="text" maxLength={15} value={fname} onChange={handleFirstNameChange} />
            </Field>
            <Field label="Last Name" required hint={`${lname.length}/15`}>
              <input className={inputClass} type="text" maxLength={15} value={lname} onChange={handleLastNameChange} />
            </Field>
            <Field label="Mobile" required>
              <input className={inputClass} type="number" value={mobile} onChange={handleMobileChange} />
            </Field>
            <Field label="Email" required>
              <input className={inputClass} type="email" value={email} onChange={handleEmailChange} />
            </Field>
          </div>

          <Field label="Address" required hint={`${address.length}/300`}>
            <textarea className={inputClass} rows={3} maxLength={300} value={address} onChange={handleAddressChange} />
          </Field>

          <div className="grid grid-cols-1 gap-x-4 sm:grid-cols-2">
            <Field label="Date of Joining" required>
              <input
                className={inputClass}
                type="date"
                max={moment().format("YYYY-MM-DD")}
                value={doj ? moment(doj).format("YYYY-MM-DD") : ""}
                onChange={handleDojChange}
              />
            </Field>
            <Field label="Date of Birth" required>
              <input
                className={inputClass}
                type="date"
                max={moment().format("YYYY-MM-DD")}
                value={dob ? moment(dob).format("YYYY-MM-DD") : ""}
                onChange={handleDobChange}
              />
            </Field>
          </div>

          <p className={labelClass}>Years of experience during joining</p>
          <div className="mb-1 flex items-center gap-3">
            <input
              className={`${inputClass} w-24`}
              type="number"
              min={0}
              placeholder="Years"
              value={year}
              onChange={handleYearChange}
            />
            <select className={`${inputClass} w-28`} value={month} onChange={handleMonthChange}>
              {Array.from({ length: 12 }, (_, i) => (
                <option key={i} value={i}>{i} mo</option>
              ))}
            </select>
            <p className="text-xs font-medium text-gray-500">= {overallExperience} overall</p>
          </div>

          <div className="mb-4 mt-4">
            <p className={labelClass}>Gender</p>
            <div className="flex gap-2">
              {["female", "male"].map((g) => (
                <button
                  key={g}
                  type="button"
                  onClick={() => handleGenderChange({ target: { value: g } })}
                  className={`rounded-lg border px-4 py-2 text-sm font-medium capitalize transition-colors ${
                    gender === g
                      ? "border-[#262673] bg-[#262673]/5 text-[#262673]"
                      : "border-gray-200 text-gray-500 hover:bg-gray-50"
                  }`}
                >
                  {g}
                </button>
              ))}
            </div>
          </div>
        </>
      ),
    },
    {
      label: 'Member Credential',
      icon: <RiLockPasswordFill size={22} className="text-[#0B6BCB]" />,
      validate: validateCredential,
      description: (
        <>
          <Field label="Member ID" required>
            <input className={inputClass} type="text" value={memberId} onChange={handleIdChange} />
          </Field>
          <Field label="Password">
            <input className={`${inputClass} cursor-not-allowed bg-gray-50 text-gray-400`} type="text" disabled value={password} />
          </Field>
        </>
      ),
    },
    {
      label: 'Designation & Role',
      icon: <HiUserGroup size={22} className="text-[#0B6BCB]" />,
      validate: null,
      description: (
        <>
          <p className={labelClass}>Roles</p>
          <div className="mb-4 flex flex-wrap gap-3">
            {roleObj.map((num) => (
              <label
                key={num.value}
                className={`flex cursor-pointer flex-col items-center gap-2 rounded-xl border px-5 py-4 text-sm transition-all ${
                  role === num.value
                    ? "border-[#262673] bg-[#262673]/5 shadow-sm"
                    : "border-gray-200 hover:border-gray-300"
                }`}
              >
                <input
                  type="radio"
                  name="member-role"
                  value={num.value}
                  checked={role === num.value}
                  onChange={handleRoleChange}
                  className="hidden"
                />
                <IoCheckmarkCircle
                  size={22}
                  className={role === num.value ? "text-[#262673]" : "text-gray-200"}
                />
                <span className={`font-medium ${role === num.value ? "text-[#262673]" : "text-gray-500"}`}>
                  {num.label}
                </span>
              </label>
            ))}
          </div>

          <Field label="Designation" required hint={`${designation.length}/30`}>
            <input className={inputClass} type="text" maxLength={30} value={designation} onChange={handleDesignationChange} />
          </Field>
        </>
      ),
    },
  ];

  const [activeStep, setActiveStep] = React.useState(0);
  const maxSteps = steps.length;

  const handleNext = () => {
    if (!steps[activeStep].validate || steps[activeStep].validate()) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => setActiveStep((prev) => prev - 1);

  return (
   <div className="flex max-h-[85vh] flex-col">
      {/* Step header */}
      <div className="relative border-b border-gray-100 px-6 pb-4 pt-6">
        <button
          onClick={addMemberModal}
          className="absolute right-4 top-4 flex h-7 w-7 items-center justify-center rounded-full text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-700"
        >
          <IoClose size={18} />
        </button>

        <div className="mb-4 flex items-center gap-3 pr-8">
          <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue-50">
            {steps[activeStep].icon}
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-gray-400">
              Step {activeStep + 1} of {maxSteps}
            </p>
            <p className="text-sm font-bold text-[#0B6BCB]">{steps[activeStep].label}</p>
          </div>
        </div>

        {/* Progress bar */}
        <div className="flex gap-1.5">
          {steps.map((_, i) => (
            <div
              key={i}
              className={`h-1.5 flex-1 rounded-full transition-colors ${
                i <= activeStep ? "bg-[#262673]" : "bg-gray-100"
              }`}
            />
          ))}
        </div>
      </div>

      {/* Step content */}
      <div className="flex-1 overflow-y-auto px-6 py-5">
        {steps[activeStep].description}
      </div>

      {/* Footer nav */}
      <div className="flex items-center justify-between border-t border-gray-100 px-6 py-4">
        <button
          onClick={handleBack}
          disabled={activeStep === 0}
          className="flex items-center gap-1 rounded-lg px-3 py-2 text-sm font-semibold text-gray-500 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30"
        >
          <IoChevronBack size={16} /> Back
        </button>

        {activeStep !== maxSteps - 1 ? (
          <button
            onClick={handleNext}
            className="flex items-center gap-1 rounded-lg bg-[#262673] px-5 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-500"
          >
            Next <IoChevronForward size={16} />
          </button>
        ) : (
          <button
            onClick={addNewMembers}
            disabled={submitting}
            className="flex items-center gap-2 rounded-lg bg-orange-500 px-6 py-2 text-sm font-semibold text-white transition-colors hover:bg-orange-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {submitting && <span className="h-3.5 w-3.5 animate-spin rounded-full border-2 border-white/40 border-t-white" />}
            Submit
          </button>
        )}
      </div>
    </div>
  );
}